






















































































































































import { defineComponent, PropType } from '@nuxtjs/composition-api';
import ProductCartButton from '~/components/pages/Product/ProductCartButton.vue';
import TopHorizontalItems from '~/components/pages/Top/TopHorizontalItems.vue';
import TopItemCardComponent from '~/components/pages/Top/TopItemCard.vue';
import TopSection from '~/components/pages/Top/TopSection.vue';
import AppRectButton from '~/components/partials/App/AppRectButton.vue';
import { useSilverEggApi } from '~/composables/silverEgg/useSilverEggApi';
import { PRODUCT_PARAM_QUERIES } from '~/constants';
import { isInsidePeriod, url } from '~/utils';
import { getLotteryInfoFromSearch } from '~/utils/checkLotteryStatus';
import { ConvertedRecommendItem } from '~/types/common/silverEgg';
import { TopItemCard } from '~/types/modules/product';
import { TopItemDetail } from '~/types/modules/top';
import { BooleanLike, ProductSetType, ProductParentCategory } from '~/enums';

export default defineComponent({
  components: {
    TopSection,
    TopHorizontalItems,
    TopItemCard: TopItemCardComponent,
    AppRectButton,
    ProductCartButton,
  },
  props: {
    featuredWineList: {
      type: Array as PropType<TopItemDetail[]>,
      default: null,
    },
    wineSetList: {
      type: Array as PropType<TopItemDetail[]>,
      default: null,
    },
    silverEggRecommendItems: {
      type: Array as PropType<ConvertedRecommendItem[]>,
      default: null,
    },
    silverEggRecommendRqid: {
      type: String,
      required: true,
    },
    silverEggRecommendSpec: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { clickNotify } = useSilverEggApi();

    // 販売期間中かどうかを判定
    const isNowOnSale = (item: TopItemCard) => {
      return isInsidePeriod(item.sale_start, item.sale_end);
    };

    const sendClickRequest = async (productCode: string) => {
      await clickNotify({
        itemId: productCode,
        spec: props.silverEggRecommendSpec,
        rqid: props.silverEggRecommendRqid,
      });
    };

    return {
      ProductSetType,
      ProductParentCategory,
      url,
      isNowOnSale,
      PRODUCT_PARAM_QUERIES,
      BooleanLike,
      sendClickRequest,
      getLotteryInfoFromSearch,
    };
  },
});
